import {getDataWithPromise, Globals, handleAjaxError} from "root/DataFunctions/BaseDataFns";
import {FamilyMemberType} from "root/DataFunctions/Constants";

export const getChildAdoptedFamilies = (child_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/child/' + child_id + '/families/adoptee';

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
    .catch((jqXHR, textStatus, error) =>
    {
        handleAjaxError(jqXHR, textStatus, error);
    });
}

export const getChildAdoptedFamilyMembers = (child_id, family_id,  onCompleteFunc) => {

    const url = Globals.APIFolder + '/child/' + child_id + '/families/adoptee/' + family_id + '/members';

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
    .catch((jqXHR, textStatus, error) =>
    {
        handleAjaxError(jqXHR, textStatus, error);
    });
}

export const getFamilyDetails = (child_id, family_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/child/' + child_id + '/families/' + family_id;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const saveNewFamily = ( child_uid, familyFormData, onCompleteFunc) => {

    const url = Globals.APIFolder + '/child/' + child_uid + '/families';

    getDataWithPromise(url, 'POST', { formData: familyFormData }).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
};

export const updateFamily = ( child_uid, family_id, familyFormData, onCompleteFunc) => {

    const url = Globals.APIFolder + '/child/' + child_uid + '/families/' + family_id;

    getDataWithPromise(url, 'POST', {formData: familyFormData}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
};

export const deleteFamily = ( child_uid, family_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/child/' + child_uid + '/families/' + family_id;

    getDataWithPromise(url, 'DELETE', {} ).then(data =>
    {
        onCompleteFunc ( data );
    })
    .catch((jqXHR, textStatus, error) =>
    {
        handleAjaxError(jqXHR, textStatus, error);
    });
};

export const getFamilyMemberDetails = (child_id, family_member_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/child/' + child_id + '/familyMember/' + family_member_id;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const saveNewFamilyMember = ( child_uid, family_id, familyFormData, onCompleteFunc) => {

    const url = Globals.APIFolder + '/child/' + child_uid + '/families/adoptee/' + family_id + '/familyMember';

    getDataWithPromise(url, 'POST', { formData: familyFormData }).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
};

export const updateFamilyMember = ( child_uid, family_member_id, familyFormData, onCompleteFunc) => {

    const url = Globals.APIFolder + '/child/' + child_uid + '/familyMember/' + family_member_id;

    getDataWithPromise(url, 'POST', {formData: familyFormData}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
};

export const deleteFamilyMember = ( child_uid, family_member_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/child/' + child_uid + '/familyMember/' + family_member_id;

    getDataWithPromise(url, 'DELETE', {} ).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
};

// For family tree - Note Steve 20/04/2022

/*Get Family details for treee
export const getMyFamilyByType = (child_uid, family_type, onCompleteFunc) => {

    const url = Globals.APIFolder + 'child/' + child_uid + '/family/' + family_type;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}*/

//Get's details for groups such as parents, grandparents etc
export const getFamilyGroupMembers = (child_uid, familyType, relationType, onCompleteFunc) => {

    const url = Globals.APIFolder + 'child/' + child_uid + '/' + familyType + '/' + relationType ;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const getFamilyMemberImageUrl = (document_id, child_uid, member_type) => {

    var url = '';
    const member_type_id = Number(member_type);

    if(document_id === null || document_id === undefined){
        switch(member_type_id){
            case FamilyMemberType.FAMILY_MEMBER_FATHER:
            case FamilyMemberType.FAMILY_MEMBER_BROTHER:
            case FamilyMemberType.FAMILY_MEMBER_GRANDFATHER:
            case FamilyMemberType.FAMILY_MEMBER_UNCLE:
            case FamilyMemberType.FAMILY_MEMBER_NEPHEW:
                url = '/images/defaultMan.jpg';
                break;

            case FamilyMemberType.FAMILY_MEMBER_MOTHER:
            case FamilyMemberType.FAMILY_MEMBER_SISTER:
            case FamilyMemberType.FAMILY_MEMBER_GRANDMOTHER:
            case FamilyMemberType.FAMILY_MEMBER_AUNTIE:
            case FamilyMemberType.FAMILY_MEMBER_NIECE:
                url = '/images/defaultWoman.jpg';
                break;

            case FamilyMemberType.FAMILY_MEMBER_COUSIN:
            case FamilyMemberType.FAMILY_MEMBER_FRIEND:
            case FamilyMemberType.FAMILY_MEMBER_FAMILY_FRIEND:
            case FamilyMemberType.FAMILY_MEMBER_OTHER_FAMILY:
            case FamilyMemberType.FAMILY_MEMBER_OTHER:
            case FamilyMemberType.FAMILY_MEMBER_GUARDIAN:
                url = '/images/defaultPerson.jpg';
                break;

            case FamilyMemberType.FAMILY_MEMBER_PET:
                url = '/images/defaultPets.svg';
                break;

            default:
                url = '/images/defaultPerson.jpg';
        }
    }
    else{
        url = Globals.APIFolder + '/child/' + child_uid + '/document/' + document_id + '?size=100&square=false';
    }

    return url;
};